import { render } from "./Almaza city center(shopes).vue?vue&type=template&id=6fbd61de&scoped=true"
const script = {}

import "./Almaza city center(shopes).vue?vue&type=style&index=0&id=6fbd61de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6fbd61de"

export default script